import { Auditable } from '../@lib/models/commons.models';
import { IForm, IModel } from '../@lib/models/contracts.models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Document } from './document.model';
import * as moment from 'moment';

export class Places extends Auditable implements IModel, IForm {
  id: string;
  created_at: Date;
  updated_at: Date;
  created_id: string;
  created_by: string;
  update_id: string;
  update_by: string;
  active: boolean;
  tradingName: string;
  companyName: string;
  description: string;
  placeTypeId: string;
  accountId: string;
  defaultContactId: string;
 
  addressId: string;

  documentId: string;
  document: Document;
  lastNfeNumber: number;
  ie: string;
  ieExempted: boolean;
  nfeIoCompanyId: string;
  nfeIoStateTaxId: string;
  operatingHoursActive: boolean;

  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.id = other.id;
      this.created_at = other.created_at;
      this.updated_at = other.updated_at;
      this.created_id = other.created_id;
      this.created_by = other.created_by;
      this.update_id = other.update_id;
      this.update_by = other.update_by;
      this.active = other.active;
      this.tradingName = other.tradingName;
      this.companyName = other.companyName;
      this.description = other.description;
      this.placeTypeId = other.placeTypeId;
      this.accountId = other.accountId;
      this.defaultContactId = other.defaultContactId;
    
      this.lastNfeNumber = other.lastNfeNumber;
   
      this.documentId = (this.document) ? this.document.id : '';
      this.document = new Document(other.document);
      this.ie = other.ie;
      this.ieExempted = other.ieExempted;
      this.nfeIoCompanyId = other.nfeIoCompanyId;
      this.nfeIoStateTaxId = other.nfeIoStateTaxId;
      this.operatingHoursActive = other.operatingHoursActive;
    } else {
     
      this.document = new Document();
      this.operatingHoursActive = false;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        id: new FormControl(this.id),
        tradingName: new FormControl(this.tradingName, [Validators.required]),
        companyName: new FormControl(this.companyName, [Validators.required]),
        description: new FormControl(this.description),
        documentId: new FormControl((this.document) ? this.document.id : ''),
        document: this.document.asForm,
        placeTypeId: new FormControl(this.placeTypeId, [Validators.required]),
        accountId: new FormControl(this.accountId, [Validators.required]),
        defaultContactId: new FormControl(this.defaultContactId),
        lastNfeNumber: new FormControl(this.lastNfeNumber),
        ie: new FormControl(this.ie),
        ieExempted: new FormControl(this.ieExempted),
        operatingHoursActive: new FormControl(this.operatingHoursActive)
      });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }

  get report() {
    return {
      'Razão Social': this.companyName,
      'Nome Fantasia': this.tradingName,
     };
  }
}
